<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "COURSE_ASSESSMENT_UNITS" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch"
                                            (change)="getBatchCourses()">

                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <!-- <option value="202">{{ "static group" | translate | titlecase
                                                    }}
                                                </option> -->
                                                <option *ngFor="let field of batches" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="course">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <!-- <option value="770">{{ "static group" | translate |
                                                    titlecase
                                                    }}</option> -->
                                                <option *ngFor="let field of courses" [value]="field.subjectid">
                                                    {{(globals.lang == 'ar')? field.subjectNameAr :
                                                    field.subjectNameEn}} - ({{field.subjectCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.course.touched && searchForm.controls.course.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row" *ngIf="Searched">
                    <div class="col-md-4 form-group px-md-5 mb-1">
                        <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            routerLink="/scores-grades/course-assessment-units-create"
                            [queryParams]="{yearId: currentYear, semesterId: currentSemester, batchId: currentBatch, subjectId: currentCourse}"><i
                                class="fas fa-plus"></i> {{
                            "ADD" | translate |
                            titlecase }}</button>
                    </div>
                    <!-- <div class="col-sm-1">
                        <button (click)="generateExcel()" class="btn" style="height:auto"><span
                                style="font-size: 2em; color: green;"><i
                                    class="fas fa-file-excel fa-sm"></i></span></button>
                            (click)="applyOrder()"

                    </div> -->

                    <div class="col-md-4 form-group px-md-5 mb-1" *ngIf="assessUnits.length >= 1&&Searched">
                        <button class="btn btn-success" (click)="applyOrder()" class="btn btn-primary"><i
                                class="fas fa-save"></i>{{
                            "APPLY_CHANGE" | translate | titlecase }}</button>
                    </div>

                    <div class="col-md-4 form-group px-md-5 mb-1">
                        <button class="btn btn-success" (click)="copyFromPreviosSemester()" class="btn btn-info"><i
                                class="fas fa-save"></i>{{
                            "COPY_FROM_PREVIOUS_SEMESTER" | translate | titlecase }}</button>
                    </div>
                </div>


                <br />
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="assessUnits.length >= 1&& Searched" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "COURSE" | translate | titlecase }}</th>
                                <th>{{ "ASSESS_UNIT" | translate | titlecase }}</th>

                                <th>{{ "ORDER" | translate | titlecase }}</th>
                                <th>{{ "SCORE" | translate | titlecase }}</th>
                                <th>{{ "WEIGHT" | translate | titlecase }}</th>

                                <th>{{ "EXAM_NAME_EN" | translate | titlecase }}</th>
                                <th>{{ "EXAM_NAME_AR" | translate | titlecase }}</th>
                                <th>{{ "ACTIVE" | translate | titlecase }}</th>

                                <th class="border-0 font-14 px-2 text-grey">{{ "EDIT" | translate | titlecase
                                    }}</th>
                                <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of assessUnits let i = index">
                                <td>{{res?.no}}</td>
                                <td>{{res?.id}}</td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.course?.subjectNameAr : res?.course?.subjectNameEn
                                    }}
                                </td>
                                <td>
                                    {{
                                    (globals.lang == 'ar')? res?.assUnit?.asesUnitNameAr : res?.assUnit?.asesUnitNameEn
                                    }}
                                </td>

                                <td>{{res?.orderNo}}</td>
                                <td>{{res?.totalScore}}</td>
                                <td>{{res?.totalScorePercent}}</td>

                                <td>{{res?.subjAsesNameEn}}</td>
                                <td>{{res?.subjAsesNameAr}}</td>
                                <td>{{res?.active}}</td>

                                <td class="text-bold text-warning">
                                    <a class="btn btn-sm btn-link text-warning"
                                        routerLink="/scores-grades/course-assessment-units-update"
                                        [queryParams]="{courseAssUnitId: res?.id, yearId: currentYear, semesterId: currentSemester, batchId: currentBatch, subjectId: currentCourse}"><i class="fas fa-edit"></i>
                                        {{ "MODIFY" | translate | titlecase }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


</div>
